// import React from "react";
import "./LaunchingPage.scss";
import { useDocument } from "../../firebase-files/hooks/useDocument";
const LaunchingPage = () => {
  const { document: dbLaunchingPageDocuments, error: dbLaunchingPageError } =
    useDocument("settings", "organisation");

  const { document: socialMedia, error: socialMediaError } = useDocument(
    "settings",
    "socialmedia"
  );
  return (
    <div className="launching_page_right_parent">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-6 flex-column">
            <div className="col-12 col-md-6 col-lg-6 d-flex align-items-center justify-content-center">
              <div className="launching_page_right_pc">
                <img
                  src="https://assets-v2.lottiefiles.com/a/e215d8a2-1172-11ee-a51d-03c397823a85/uId0jDvyBM.gif"
                  alt="rocket gif"
                />
              </div>
            </div>
            <div className="launching_page_left">
              <img
                src={
                  dbLaunchingPageDocuments && dbLaunchingPageDocuments.logoUrl
                }
                alt="site logo"
              />
              <div style={{ marginTop: "25px" }}>
                <p>Website is under maintenance</p>
                <h1>
                  <span> Fasten Your Seat Belt : </span> An Exciting
                  Transformation is on your way!
                </h1>
                <div>
                  <div className="d-flex social-icons-wrapper">
                    {/* Facebook */}
                    {socialMedia?.socialmedia?.facebook && (
                      <div className="social-icon-box">
                        <a
                          href={socialMedia.socialmedia.facebook}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                          >
                            <path
                              d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
                              fill="var(--white-color)"
                            />
                          </svg>
                        </a>
                      </div>
                    )}

                    {/* Instagram */}
                    {socialMedia?.socialmedia?.instagram && (
                      <div className="social-icon-box">
                        <a
                          href={socialMedia.socialmedia.instagram}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ffffff"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <rect
                              x="2"
                              y="2"
                              width="20"
                              height="20"
                              rx="5"
                              ry="5"
                            ></rect>
                            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                          </svg>
                        </a>
                      </div>
                    )}

                    {/* LinkedIn */}
                    {socialMedia?.socialmedia?.linkedin && (
                      <div className="social-icon-box">
                        <a
                          href={socialMedia.socialmedia.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                          >
                            <path
                              d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416z"
                              fill="var(--white-color)"
                            />
                          </svg>
                        </a>
                      </div>
                    )}

                    {/* YouTube */}
                    {socialMedia?.socialmedia?.youtube && (
                      <div className="social-icon-box">
                        <a
                          href={socialMedia.socialmedia.youtube}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                          >
                            <path
                              d="M282 256.2l-95.2-54.1V310.3L282 256.2z"
                              fill="var(--white-color)"
                            />
                          </svg>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-6 d-flex align-items-center justify-content-center">
            <div className="launching_page_right">
              <img
                src="https://assets-v2.lottiefiles.com/a/e215d8a2-1172-11ee-a51d-03c397823a85/uId0jDvyBM.gif"
                alt="rocket gif"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LaunchingPage;
